import { memoize } from "lodash";
import { outsourceCommonTipTexts } from "services/api";

const getTipText = async (option: any) => {
  const { keys, demand_id } = option;
  if (!!keys?.length && demand_id) {
    const res = await outsourceCommonTipTexts({
      demand_id: option.demand_id,
      keys: keys.map((v: string) => `demand_plan_info.${v}`),
    })
    return res?.data?.find((v: any) => v.tip_type === 'question-hover')?.tip_text;
  }

  return ''
}

const memoizeGetTipText = memoize(getTipText, (option) => option && JSON.stringify(option));

const HALF_COL_SPAN_PROPS = {
  itemColProps: { span: 12 },
  itemLabelColProps: { span: 8 },
  itemInputColProps: { span: 16 },
};

const ENTIRE_COL_SPAN_PROPS = {
  itemColProps: { span: 24 },
  itemLabelColProps: { span: 4 },
  itemInputColProps: { span: 20 },
};

const TEXTAREA_PROPS = {
  minHeight: 74,
  maxHeight: 74,
  maxLength: 800,
};

const INPUT_PROPS = {
  maxLength: 200,
};

export const FORM_ITEM_PROPS_BASE = {
  project_planners: { name: '策划', componentClass: 'select' },
  budget: { name: '预算', componentClass: 'inputNumber' },
  activity_address: { name: '活动地点', componentClass: 'input' },
  activity_time: { name: '活动时间', componentClass: 'datePicker' },
  participate_duration: { name: '参与时长', componentClass: 'input' },
  rehearsal_time: { name: '彩排时间', componentClass: 'datePicker' },
  intended_person: { name: '意向人选', componentClass: 'input' },
  clothing: { name: '服装', componentClass: 'radio' },
  need_guest_cooperate: { name: '需嘉宾配合内容', componentClass: 'textarea' },
  put_in_style: { name: '投放形式', componentClass: 'radio' },
  live_address: { name: '直播地点', componentClass: 'input' },
  put_in_platform: { name: '投放平台', componentClass: 'input' },
  put_in_time: { name: '投放时间', componentClass: 'input' },
  put_in_content: { name: '投放内容', componentClass: 'textarea' },
  put_in_require: { name: '投放要求', componentClass: 'textarea' },
  purpose_kol: { name: '意向KOL', componentClass: 'input' },
  live_platform: { name: '直播平台', componentClass: 'textarea' },
  make_period: { name: '制作周期', componentClass: 'input' },
  make_require: { name: '制作要求', componentClass: 'textarea' },
  purchase_time: { name: '采购时间', componentClass: 'datePicker' },
  materials_info: { name: '物品信息', componentClass: 'input' },
  use_address: { name: '使用地点', componentClass: 'input' },
  rent_begin_time: { name: '租赁开始时间', componentClass: 'datePicker' },
  rent_end_time: { name: '租赁结束时间', componentClass: 'datePicker' },
  attach_demand: { name: '附带需求', componentClass: 'textarea' },
  manuscript_use_type: { name: '稿件用途类型', componentClass: 'select' },
  style_defined: { name: '风格划定', componentClass: 'select' },
  cooperate_content: { name: '需求合作内容', componentClass: 'input' },
  quantity: { name: '数量', componentClass: 'inputNumber' },
  sola_budget: { name: '单张预算', componentClass: 'inputNumber' },
  px_require: { name: '像素要求', componentClass: 'input' },
  video_retain_time: { name: '视频存留时间', componentClass: 'VideoRetain', mode: 'select' },
  duration: { name: '时长', componentClass: 'input' },
  style_require: { name: '风格要求', componentClass: 'select' },
  demand_publish: { name: '发布需求', componentClass: 'input' },
  press_time: { name: '截稿时间', componentClass: 'datePicker' },
  article_word_number: { name: '文章字数', componentClass: 'input' },
  begin_at: { name: '开始时间', labelTip: memoizeGetTipText, componentClass: 'datePicker', },
  end_at: { name: '结束时间', labelTip: memoizeGetTipText, componentClass: 'datePicker' },
  video_refer_link: { name: '参考视频链接', componentClass: 'input' },
  content_direction: { name: '内容/方向', componentClass: 'textarea' },
  demand_detail: { name: '需求详情', componentClass: 'textarea' },
  specific_rights: { name: '具体权益', componentClass: 'textarea' },
  embodiment_implant: { name: '体现植入点', componentClass: 'textarea' },
  screen_record_time: { name: '需录屏时间', componentClass: 'input' },
  direct_broadcast_link: { name: '直播间链接', componentClass: 'textarea' },
  brush_list_topic: { name: '刷榜话题', componentClass: 'input' },
  brush_list_time: { name: '刷榜时间', componentClass: 'datePicker' },
  plan_attachs_blob_ids: {
    name: '策划案',
    componentClass: 'upload',
    saveKey: 'plan_attachs_blob_ids',
    uploadBody: { attach_type: 'plan_attachs' },
  },
  purchase_list: {
    name: '采购清单',
    componentClass: 'upload',
    saveKey: 'purchase_attachs_blob_ids',
    uploadBody: { attach_type: 'purchase_attachs' },
  },
  refer_content: {
    name: '参考内容',
    saveKey: 'reference_attachs_blob_ids',
    componentClass: 'upload',
    uploadBody: { attach_type: 'plan_attachs' },
  },
};

export const FORM_ITEM_PROPS = Object.keys(FORM_ITEM_PROPS_BASE).reduce((acc: any, cur: string) => {
  const otherProps = {};
  const componentClass = FORM_ITEM_PROPS_BASE[cur].componentClass;
  if (!!~['textarea', 'upload'].indexOf(componentClass)) {
    Object.assign(otherProps, TEXTAREA_PROPS, ENTIRE_COL_SPAN_PROPS);
  } else if (!!~['input'].indexOf(componentClass)) {
    Object.assign(otherProps, INPUT_PROPS, HALF_COL_SPAN_PROPS);
  } else {
    Object.assign(otherProps, HALF_COL_SPAN_PROPS);
  }
  acc[cur] = { ...FORM_ITEM_PROPS_BASE[cur], ...otherProps };
  return acc;
}, {});

export const FORM_ITEM_ORDERS = Object.keys(FORM_ITEM_PROPS);

export const FULL_COL_PROPS_KEY = Object.keys(FORM_ITEM_PROPS_BASE)
  .reduce((prev: any, curr: string) => {
    if (FORM_ITEM_PROPS_BASE[curr].componentClass === 'textarea') {
      prev.push(curr);
    }
    return prev;
  }, []);
